import React from "react";
import {
  Grid,
  TextField,
  Checkbox,
  FormControlLabel,
  MenuItem,
} from "@mui/material";

const ComponentMetaSection = ({ form, updateField }) => {
  return (
    <>
      <Grid item xs={12}>
        <FormControlLabel
          control={
            <Checkbox
              checked={form.isComponent}
              onChange={(e) => updateField("isComponent", e.target.checked)}
            />
          }
          label="Mark as reusable component"
        />
      </Grid>

      {form.isComponent && (
        <>
          <Grid item xs={6}>
            <TextField
              label="Component Name"
              fullWidth
              value={form.name || ""}
              onChange={(e) => updateField("name", e.target.value)}
            />
          </Grid>

          <Grid item xs={3}>
            <TextField
              type="number"
              label="Total Yield"
              fullWidth
              value={form.componentYield || ""}
              onChange={(e) =>
                updateField("componentYield", Number(e.target.value))
              }
            />
          </Grid>

          <Grid item xs={3}>
            <TextField
              select
              label="Yield Unit"
              fullWidth
              value={form.componentYieldUnit || "g"}
              onChange={(e) =>
                updateField("componentYieldUnit", e.target.value)
              }>
              {["g", "kg", "ml", "l", "pcs"].map((unit) => (
                <MenuItem key={unit} value={unit}>
                  {unit}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
        </>
      )}
    </>
  );
};

export default ComponentMetaSection;
